import Script from "next/script";
const SearchSchema = ({
  schema,
  id = "json-ld"
}) => {
  return <Script id={id} type="application/ld+json" strategy="afterInteractive" data-sentry-element="Script" data-sentry-component="SearchSchema" data-sentry-source-file="SchemaMarkup.jsx">
      {JSON.stringify(schema)}
    </Script>;
};
export default SearchSchema;